(() => {
  // History restoration can bring back stale cart HTML after visiting checkout.
  window.addEventListener('pageshow', async event => {
    if (!event.persisted && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    try {
      const response = await fetch(`${FoxTheme.routes.root_url}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
    } catch (_) { /* Native cart actions remain available if the refresh is offline. */ }
  });
  // Pointer interactions stay clean; keyboard navigation retains a visible focus ring.
  document.addEventListener('pointerdown', () => document.documentElement.classList.add('p9-pointer-input'), {passive:true,capture:true});
  document.addEventListener('keydown', event => { if (event.key === 'Tab') document.documentElement.classList.remove('p9-pointer-input'); }, true);
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const prefetched = new Set();
  let timer;
  const prefetch = link => {
    if (!link || prefetched.size >= 8) return;
    const url = new URL(link.href, location.href);
    const query = [...url.searchParams];
    const productVariantQuery = /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[^/]+\/?$/.test(url.pathname) && query.length === 1 && query[0][0] === 'variant' && /^[1-9]\d*$/.test(query[0][1]);
    if (url.origin !== location.origin || (url.search && !productVariantQuery) || url.hash || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:products|collections|blogs|pages)\//.test(url.pathname) || url.pathname === location.pathname || prefetched.has(url.href)) return;
    prefetched.add(url.href);
    const hint = document.createElement('link');
    hint.rel = 'prefetch'; hint.as = 'document'; hint.href = url.href; hint.fetchPriority = 'low';
    document.head.append(hint);
  };
  document.addEventListener('pointerover', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.contains(event.relatedTarget)) return;
    clearTimeout(timer); timer = setTimeout(() => prefetch(link), 90);
  }, {passive:true});
  document.addEventListener('pointerout', event => { if (event.target.closest('a[href]')) clearTimeout(timer); }, {passive:true});
  document.addEventListener('pointerdown', event => prefetch(event.target.closest('a[href]')), {passive:true});
  document.addEventListener('focusin', event => prefetch(event.target.closest('a[href]')));
})();
